import * as R from 'ramda';

const clear = () => (state, id) => {
    const userClientId = state.user.selectedUserClientId;
    const notificationsLens = R.lensPath([
        'clients',
        userClientId,
        'notifications',
    ]);
    const doesntMatchId = R.propSatisfies(cId => cId !== id, 'id');
    const filterMatchingId = R.filter(doesntMatchId);

    return R.over(notificationsLens, filterMatchingId, state);
};

export default clear;
